import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import OptionInput from '../../OptionButton';
import { siteId } from '../../../utils';
import { WrapperSection, Title, WrapperInputs } from './styles';

const OperationType = ({ device, register, setValue, watch, disabled }) => {
  const { t } = useTranslation();
  const isPortalWithFourOperationType = ['IWBR', 'WIBR'].includes(siteId);
  const operationTypesIds = isPortalWithFourOperationType ? ['1', '2', '4', '3'] : ['1', '2', '4'];
  const selectedOperations = watch('operationType');
  const selected = Array.isArray(selectedOperations) ? selectedOperations : [];

  const handleChange = e => {
    const { value, name } = e.target;
    const isSelected = selected.includes(value);
    setValue(name, isSelected ? selected.filter(op => op !== value) : [...selected, value]);
  };

  return (
    <WrapperSection data-publi='mainData-operationType'>
      <Title data-publi='mainData-operationType-title'>{t('professionalPubli.main.operationType')}</Title>
      <WrapperInputs device={device}>
        {operationTypesIds.map(operation => (
          <OptionInput
            device={device}
            key={operation}
            name='operationType'
            value={operation}
            selected={selected.includes(operation)}
            onChange={handleChange}
            label={t(`professionalPubli.main.operationType.${operation}`)}
            register={register}
            withTooltip
            disabled={disabled}
          />
        ))}
      </WrapperInputs>
    </WrapperSection>
  );
};

OperationType.propTypes = {
  device: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export { OperationType };
